import type { LoaderProps } from '@/components/landing-page/components/loader';
import clsx from 'clsx';
import { defaults } from '@/components/landing-page/components/loader';
import cn from '@/components/landing-page/components/loader/loader.module.css';

const Loader = (props: LoaderProps) => {
  const { text = defaults.text, className = defaults.className } = props;

  return (
    <div className={clsx(cn.Loader, className)}>
      <div className={cn.Content}>
        <div className={cn.Image}>
          <div className={cn.Line} />
          <div className={cn.Point} />
        </div>
        <div data-testid='loader' className={cn.Text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

export default Loader;
